import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userProfile from '@/features/sliceUserProfile';
import notification from '@/features/sliceNotification';
import loadings from '@/features/sliceLoading';
import checkEmail from '@/features/sliceUserEmail';
import ui from '@/features/ui/sliceMobileMenu';
import auth from '@/features/sliceAuth';

export const store = configureStore({
  reducer: {
    auth,
    loadingList: loadings,
    userProfile,
    notification,
    checkEmail,
    ui,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
ReturnType,
RootState,
unknown,
Action<string>
>;
